<template>
  <div class="kjqg-content" ref="kjqg" :class="{qycx: navActiveIndex == 4}">
    <div class="index-nav " :class="navActiveIndex > 0 && 'type2'">
      <div class="nav-item " :class="(navActiveIndex == 2 || navActiveIndex == 1 ) && 'active'" @click="changeSlide(1)"></div>
      <div class="nav-item" :class="(navActiveIndex == 3 ) && 'active'" @click="changeSlide(3)"></div>
      <div class="nav-item" :class="(navActiveIndex == 4 ) && 'active'" @click="changeSlide(4)"></div>
      <div class="nav-item" :class="(navActiveIndex == 5 ) && 'active'" @click="changeSlide(5)"></div>
      <div class="nav-item" :class="(navActiveIndex == 6 ) && 'active'" @click="changeSlide(6)"></div>
      <div class="nav-item" :class="(navActiveIndex == 7 || navActiveIndex == 8 )  && 'active'" @click="changeSlide(7)"></div>
    </div>
    <div class="swiper-content">
      <!-- 不能滑动加 class="swiper-no-swiping" -->
      <swiper ref="navSwiper" :options="navSwiper" >
        <!-- <swiper ref="navSwiper" :options="navSwiper" class="swiper-no-swiping"> -->
        <swiperSlide class="swiper-no-swiping">
          <kjqgIndex></kjqgIndex>
        </swiperSlide>
        <swiperSlide>
          <xskj :scaling="scaling" :navActiveIndex="navActiveIndex"></xskj>
        </swiperSlide>
        <swiperSlide class="swiper-no-swiping" >
          <zcyg :scaling="scaling"></zcyg>
        </swiperSlide>
        <swiperSlide class="swiper-no-swiping">
          <bnkj :scaling="scaling"></bnkj>
        </swiperSlide>
        <swiperSlide class="swiper-no-swiping">
          <qycx :scaling="scaling"></qycx>
        </swiperSlide>
        <swiperSlide class="swiper-no-swiping">
          <kjfw :scaling="scaling"></kjfw>
        </swiperSlide>
        <swiperSlide class="swiper-no-swiping">
          <kjyr :scaling="scaling"></kjyr>
        </swiperSlide>
        <swiperSlide class="swiper-no-swiping">
          <kcjs :scaling="scaling"></kcjs>
        </swiperSlide>
        <swiperSlide>
          <kcjs2 :scaling="scaling"></kcjs2>
        </swiperSlide>
      </swiper>
    </div>
    <div class="nav-tabs" :class="{fixed1: navActiveIndex > 0}" ref="navTabs">
      <div class="tabs-item" :class="(navActiveIndex == 2 || navActiveIndex == 1 ) && 'active'">
        <div class="item-left" @click="toMoreList(0)"> 政策驱动科创</div>
        <div class="item-right">学政策</div>
      </div>
      <div class="tabs-item" :class="(navActiveIndex == 3 ) && 'active'">
        <div class="item-left" @click="toMoreList(1)"> 百年科技华章</div>
        <div class="item-right">明历史</div>
      </div>
      <div class="tabs-item" :class="(navActiveIndex == 4 ) && 'active'">
        <div class="item-left" @click="toMoreList(2)"> 前沿创新争锋</div>
        <div class="item-right">探前沿</div>
      </div>
      <div class="tabs-item" :class="(navActiveIndex == 5 ) && 'active'">
        <div class="item-left" @click="toMoreList(3)"> 科技服务民生</div>
        <div class="item-right">促应用</div>
      </div>
      <div class="tabs-item" :class="(navActiveIndex == 6 ) && 'active'">
        <div class="item-left" @click="toMoreList(4)"> 专业科技育人</div>
        <div class="item-right">育人才</div>
      </div>
      <div class="tabs-item" :class="(navActiveIndex == 7 || navActiveIndex == 8 ) && 'active'">
        <div class="item-left" @click="toMoreList(5)"> 科创精神共鸣</div>
        <div class="item-right">悟精神</div>
      </div>
    </div>
  </div>
</template>

<script>
import kjqgIndex from "../components/kjqgIndex.vue";
import xskj from "../components/xskj1-1.vue";
import zcyg from "../components/zcyg1-2.vue";
// import zcyg from "../components/zcyg.vue";
import kjyr from "../components/kjyr.vue";
import kcjs from "../components/kcjs1-1.vue";
import bnkj from "../components/bnkj.vue";
import kcjs2 from "../components/kcjs1-2.vue";
import kjfw from "../components/kjfw.vue";
import qycx from "../components/qycx.vue";
import { mapActions } from "vuex";

import { swiper, swiperSlide } from "vue-awesome-swiper";
export default {
  components: {
    kjqgIndex,
    xskj,
    kjyr,
    kcjs,
    zcyg,
    bnkj,
    kcjs2,
    kjfw,
    qycx,
    swiper,
    swiperSlide,
  },
  mounted() {
    let that = this
    this.setScale()
    window.addEventListener("resize", function () {
      that.setScale()
    })

  },
  data() {
    let self = this;
    return {
      navActiveIndex: 0,
      scaling: 1,
      school_code: localStorage.getItem("schoolCode"),
      navSwiper: {
        direction: "vertical",
        followFinger: true,
        mousewheel: true,
        preventClicksPropagation: true,
        on: {
          slideChange: function (e) {
            self.navActiveIndex = this.activeIndex;
          },
        },
      },
      navList: [
        {
          path: "zcqdkc",
        },
        {
          path: "bnkjhz",
        },
        {
          path: "qycxzf",
        },
        {
          path: "kjfwms",
        },
        {
          path: "zykjyr",
        },
        {
          path: "kcjsgm",
        },
      ]
    };
  },
  methods: {
    ...mapActions(["goAppsDetailsBeforeLogin"]),
    toMoreList(ind) {
      this.goAppsDetailsBeforeLogin().then(() => {
        let routeUrl = this.$router.resolve({
          path: `/${this.school_code}/kjqg/${this.navList[ind].path}`,
        });
        window.open(routeUrl.href, "_blank");
      });
    },
    setScale() {
      // console.log(this.$refs.kjqg.offsetHeight, this.$refs.navTabs.offsetHeight);
      // if (this.$refs.kjqg.offsetWidth > 1920) {
      //   this.scaling = 1
      // } else {
      //   this.scaling = (this.$refs.kjqg.offsetHeight - this.$refs.navTabs.offsetHeight) / 981

      // }
      this.scaling = (this.$refs.kjqg.offsetHeight - this.$refs.navTabs.offsetHeight) / 981

    },
    changeSlide(ind) {
      this.$refs.navSwiper.swiper.slideTo(ind);
    },
  }
}
</script>

<style lang="less" scoped>
.kjqg-content {
  width: 100%;
  height: 100vh;
  background-image: url("../../../assets/image/kjqg/index/xskj/xskj-bg.png");
  background-size: cover;
  background-position: center;
  &.qycx {
  background-image: url("../../../assets/image/kjqg/index/qycx/qycx-bg.png");

  }
  .index-nav {
    display: flex;
    flex-direction: column;
    position: absolute;
    right: 40px;
    top: 50%;
    transform: translateY(-50%);
    z-index: 11;
    &.type2 {
      &::before {
        background: #87b1ed;
        opacity: 0.2;
      }
      .nav-item {
        background-image: url("../../../assets/image/kjqg/index/index-nav-item2.png");

        &.active {
          background-image: url("../../../assets/image/kjqg/index/index-naav-item2-active.png");
        }
      }
    }
    &::before {
      position: absolute;
      content: "";
      display: block;
      width: 2px;
      height: 100%;
      background: #d3f4ff;
      opacity: 0.16;
      left: 50%;
      //   top: ;
    }
    .nav-item {
      width: 32px;
      height: 32px;
      background-image: url("../../../assets/image/kjqg/index/index-nav-item.png");
      background-position: center;
      background-size: 23px 23px;
      background-repeat: no-repeat;
      margin-bottom: 45px;
      position: relative;
      cursor: pointer;
      &.active {
        background-image: url("../../../assets/image/kjqg/index/index-naav-item-active.png");
      }
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
  .swiper-content {
    width: 100%;
    height: 100%;
    .swiper-container {
      width: 100%;
      height: 100%;
    }
  }
  .nav-tabs {
    width: 100%;
    height: 6.35vw;
    background: linear-gradient(90deg, #1579E6 0%, #1865E4 100%);
    border: 1px solid #6fcaff;
    position: absolute;
    z-index: 10;
    bottom: 0;
    display: flex;
    justify-content: center;
    transition: all 0.3s;
    &.fixed1 {
      // top: 0;
      bottom: calc(100% - 5.16vw);
      height: 5.16vw;
    }
    .tabs-item {
      display: flex;
      align-items: center;

      &:last-child {
        &::after {
          display: none;
        }
      }
      &::after {
        content: "";
        display: inline-block;
        width: 1.77vw;
        height: 2.19vw;
        background-image: url("../../../assets/image/kjqg/index/tab-split.png");
        margin: 0 0.625vw 0 0.9vw;
        background-size: cover;
      }
      &:nth-child(1) {
        &.active {
          .item-left {
            background-image: url("../../../assets/image/kjqg/index/index-tab-1-active.png");
          }
        }
        &:hover {
          .item-left {
            background-image: url("../../../assets/image/kjqg/index/index-tab-1-active.png");
          }
        }
        .item-left {
          background-image: url("../../../assets/image/kjqg/index/index-tab-1.png");
          font-weight: bold;
          color: #ffffff;
          text-shadow: 0px 0px 2px rgba(24, 37, 121, 0.66);
          &::before {
            content: "";
            display: inline-block;
            width: 1.46vw;
            height: 1.46vw;
            background-image: url("../../../assets/image/kjqg/index/tab-icon1.png");
            background-size: cover;
            background-position: center;
          }
        }
        .item-right {
          color: #ffcba9;
        }
      }
      &:nth-child(2) {
        &.active {
          .item-left {
            background-image: url("../../../assets/image/kjqg/index/index-tab-2-active.png");
          }
        }
        &:hover {
          .item-left {
            background-image: url("../../../assets/image/kjqg/index/index-tab-2-active.png");
          }
        }
        .item-left {
          background-image: url("../../../assets/image/kjqg/index/index-tab-2.png");
          font-weight: bold;
          color: #ffffff;
          text-shadow: 0px 0px 8px rgba(24, 37, 121, 0.88);
          &::before {
            content: "";
            display: inline-block;
            width: 1.3vw;
            height: 1.46vw;
            background-image: url("../../../assets/image/kjqg/index/tab-icon2.png");
            background-size: cover;
            background-position: center;
          }
        }
        .item-right {
          color: #a2e6ff;
        }
      }
      &:nth-child(3) {
        &.active {
          .item-left {
            background-image: url("../../../assets/image/kjqg/index/index-tab-3-active.png");
          }
        }
        &:hover {
          .item-left {
            background-image: url("../../../assets/image/kjqg/index/index-tab-3-active.png");
          }
        }
        .item-left {
          background-image: url("../../../assets/image/kjqg/index/index-tab-3.png");
          font-weight: bold;
          color: #ffffff;
          text-shadow: 0px 0px 8px rgba(24, 37, 121, 0.88);
          &::before {
            content: "";
            display: inline-block;
            width: 1.35vw;
            height: 1.35vw;
            background-image: url("../../../assets/image/kjqg/index/tab-icon3.png");
            background-size: cover;
            background-position: center;
          }
        }
        .item-right {
          color: #dbc8ff;
        }
      }
      &:nth-child(4) {
        &.active {
          .item-left {
            background-image: url("../../../assets/image/kjqg/index/index-tab-4-active.png");
          }
        }
        &:hover {
          .item-left {
            background-image: url("../../../assets/image/kjqg/index/index-tab-4-active.png");
          }
        }
        .item-left {
          background-image: url("../../../assets/image/kjqg/index/index-tab-4.png");
          font-weight: bold;
          color: #ffffff;
          text-shadow: 0px 0px 8px rgba(24, 37, 121, 0.88);
          &::before {
            content: "";
            display: inline-block;
            width: 1.78vw;
            height: 1.35vw;
            background-image: url("../../../assets/image/kjqg/index/tab-icon4.png");
            background-size: cover;
            background-position: center;
          }
        }
        .item-right {
          color: #47ffde;
        }
      }
      &:nth-child(5) {
        &.active {
          .item-left {
            background-image: url("../../../assets/image/kjqg/index/index-tab-5-active.png");
          }
        }
        &:hover {
          .item-left {
            background-image: url("../../../assets/image/kjqg/index/index-tab-5-active.png");
          }
        }
        .item-left {
          background-image: url("../../../assets/image/kjqg/index/index-tab-5.png");
          font-weight: bold;
          color: #ffffff;
          text-shadow: 0px 0px 8px rgba(24, 37, 121, 0.88);
          &::before {
            content: "";
            display: inline-block;
            width: 1.3vw;
            height: 1.35vw;
            background-image: url("../../../assets/image/kjqg/index/tab-icon5.png");
            background-size: cover;
            background-position: center;
          }
        }
        .item-right {
          color: #ffcac9;
        }
      }
      &:nth-child(6) {
        &.active {
          .item-left {
            background-image: url("../../../assets/image/kjqg/index/index-tab-6-active.png");
          }
        }
        &:hover {
          .item-left {
            background-image: url("../../../assets/image/kjqg/index/index-tab-6-active.png");
          }
        }
        .item-left {
          background-image: url("../../../assets/image/kjqg/index/index-tab-6.png");
          font-weight: bold;
          color: #ffffff;
          text-shadow: 0px 0px 8px rgba(24, 37, 121, 0.88);
          &::before {
            content: "";
            display: inline-block;
            width: 1.25vw;
            height: 1.46vw;
            background-image: url("../../../assets/image/kjqg/index/tab-icon6.png");
            background-size: cover;
            background-position: center;
          }
        }
        .item-right {
          color: #7ef9ff;
        }
      }
      .item-left {
        width: 11.5vw;
        height: 4.32vw;
        background-size: cover;
        background-position: center;
        font-weight: bold;
        font-size: 0.93vw;
        display: flex;
        align-items: center;
        padding: 0 1.71vw 0 1.45vw;
        justify-content: space-between;
        cursor: pointer;
      }
      .item-right {
        font-weight: bold;
        font-size: 0.78vw;
        writing-mode: vertical-rl;
        text-align: center;
        letter-spacing: 0.2vw;
      }
    }
  }
}
</style>